<template>
  <el-row class="cs-contentContainer" v-loading="isLoading">
    <div style="padding:5px" class="cs-fullHeight cs-contentContainer-right">
      <div class="backgroud-white">
        <el-row>
          <!-- <span class="cs-title">个人信息</span>
              <el-row class="hidden-xs-only">
                <el-col :span="18">
                  <label> &nbsp; </label>
                </el-col>
          </el-row>-->
          <el-row class="grid-content">
            <el-row class="cs-teacher-title">
              <el-col :span="12" :xs="16">
                <strong>
                  <label class="el-form-item__content">{{teacher.Name}}</label>
                </strong>
                <strong>
                  <label class="el-form-item__content">&nbsp;{{teacher.Role == 1 ? "老师" : "助教"}}</label>
                </strong>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" :xs="8" class="text-right">
                <strong>
                  <label class="el-form-item__label float-right">电话号码：</label>
                </strong>
              </el-col>
              <el-col :span="8" :xs="8">
                <label class="el-form-item__content" v-text="teacher.Phone"></label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" :xs="8" class="text-right">
                <strong>
                  <label class="el-form-item__label float-right">创建日期：</label>
                </strong>
              </el-col>
              <el-col :span="8" :xs="8">
                <label class="el-form-item__content" v-text="teacher.CreateTimeText"></label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" :xs="8" class="text-right">
                <strong>
                  <label class="el-form-item__label float-right">{{teacher.Role == 1 ? "授课课数" : "分配课数"}}：</label>
                </strong>
              </el-col>
              <el-col :span="8" :xs="8">
                <label class="el-form-item__content" v-text="teacher.CourseCount"></label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" :xs="8" class="text-right">
                <strong>
                  <label class="el-form-item__label float-right">在职状态：</label>
                </strong>
              </el-col>
              <el-col :span="8" :xs="8">
                <label class="el-form-item__content" v-text="teacher.WorkStatusStr"></label>
              </el-col>
            </el-row>
          </el-row>
        </el-row>
        <hr>
      </div>
    </div>
    <teacherSpeedupCourseHistory :historyList="historyList"></teacherSpeedupCourseHistory>
  </el-row>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
  .grid-content {
    padding: 0px;
    .cs-schedule-buttonContainer {
      text-align: right;
    }

    .cs-teacher-title{
      .el-form-item__content{
        font-size: 20px;
      }
    }

  }
  .cs-schedule-bottomButton {
    margin-top: 20px;
  }
  .course-row {
    height: 30px;
    padding: 5px;
    padding-left: 10px;
  }
  .odd-course-row {
    background: whitesmoke;
  }
  .even-course-row {
    background: #ebebeb;
  }
  .term-row {
    margin-top: 40px;
  }
  .term-title {
    margin-left: 10px;
    margin-bottom: 5px;
  }
}
</style>

<script>
import { getTeacherProfile } from "../../service/teacher.service";
import teacherSpeedupCourseHistory from "./teacherSpeedupCourseHistory";

export default {
  props: {
    teacherId: Number,
  },
  data() {
    return {
      teacher: {},
      historyList:[],
      isLoading:false
    };
  },
  components: {
    teacherSpeedupCourseHistory
  },
  created(){
    this.initData();
  },
  methods: {   
    initData() {
      if (!this.teacherId){
          return;
      }
      this.isLoading = true;
      getTeacherProfile(this.teacherId)
        .then(result => {
          if (result.success) {
            this.teacher = result.data.TeacherProfile;
            this.historyList = result.data.HistoryList;
          } else {
            this.$message({
              type: "error",
              message: "获取教师失败! " + result.message
            });
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
        });
    },
    close() {
      this.teacher = {};
      this.$emit("closeDetail");
    }
  },
  watch: {
    teacherId: function(){
      this.initData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/teacherAccount/teacherProfile.vue